import { render, staticRenderFns } from "./unitItem.vue?vue&type=template&id=64574903"
import script from "./unitItem.vue?vue&type=script&lang=js"
export * from "./unitItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports